// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
    "dirty": false,
    "raw": "v1.0.2-0-g8e438b1",
    "hash": "g8e438b1",
    "distance": 0,
    "tag": "v1.0.2",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v1.0.2",
        "major": 1,
        "minor": 0,
        "patch": 2,
        "prerelease": [],
        "build": [],
        "version": "1.0.2"
    },
    "suffix": "0-g8e438b1",
    "semverString": "1.0.2",
    "version": "1.0.2",
    "versionDateTime": "2025-02-24T13:40:26.996Z"
};
